//@ts-nocheck
/* eslint-disable react/prop-types */
/* eslint no-unused-vars: 0 */

import React, { Component } from 'react'
import { withFloorMap } from '@wework/react-floormap'
import compose from '../../utils/compose'

const hoverOffset = 25

class SpaceHoverPreview extends Component {
  static defaultProps = {
    data: null,
  }

  isSubscribing = false

  hoverContainerRef = React.createRef()

  state = {
    isDragging: false,
  }

  componentDidUpdate = () => {
    const { isDragging } = this.state
    const { floorMap } = this.props
    if (!floorMap) {
      return
    }

    // This hack until we can find solution to provide floormap context before component mount
    if (this.isSubscribing) {
      return
    }

    this.isSubscribing = true
    floorMap.addEventListener('mousemove', this.handleMouseMove)
    floorMap.addEventListener('onDrag', () => {
      if (isDragging === false) {
        this.setState({ isDragging: true })
      }
    })
  }

  componentWillUnmount() {
    const { floorMap } = this.props
    if (!floorMap) {
      return
    }
    floorMap.removeEventListener('mousemove', this.handleMouseMove)
  }

  handleMouseMove = event => {
    const { isDragging } = this.state
    const { floorMap } = this.props
    const popupElement = this.hoverContainerRef.current

    const mapElement = floorMap.getDomElement()

    if (popupElement) {
      const { offsetCenter } = event.payload

      const realX = offsetCenter.x
      const realY = offsetCenter.y

      const width = popupElement.offsetWidth
      const height = popupElement.offsetHeight
      let left = realX + hoverOffset
      let top = realY + hoverOffset

      const maxX = left + width
      const maxY = top + height

      const mapWidth = mapElement.offsetWidth
      const mapHeight = mapElement.offsetHeight

      if (realX > mapWidth / 2.0) {
        // adjust the left
        left = realX - popupElement.offsetWidth - hoverOffset
      }

      if (maxY > mapHeight) {
        // adjust the top
        top -= maxY - mapHeight + 10
      }

      popupElement.style.right = ''
      popupElement.style.left = `${left}px`
      popupElement.style.top = `${top}px`
    }

    if (isDragging === true) {
      this.setState({ isDragging: false })
    }
  }

  render() {
    const {
      data,
      adaptToHeader,
      classes,
      staticHoverPreview,
      show,
      children,
      mouseLeaveCanvas,
    } = this.props

    if (!show) {
      return null
    }

    let ss = {
      position: 'absolute',
      pointerEvents: 'none',
      right: '',
    }

    if (staticHoverPreview) {
      ss = {
        position: 'absolute',
        top: adaptToHeader ? 'calc(64px + 80px)' : '80px',
        right: 400,
        pointerEvents: 'none',
      }
    } else {
      const { isDragging } = this.state

      if (isDragging || mouseLeaveCanvas) {
        return null
      }
    }

    return (
      <div
        ref={this.hoverContainerRef}
        style={{
          display: 'inline-block',
          position: 'absolute',
          top: '-9999px',
          right: '-9999px',
          zIndex: 1100,
          backgroundColor: '#fff',
          width: 360,
          boxShadow: '0px -1px 5px 1px rgba(0,0,0,.1)',
          transform: 'translateX(0)',
        }}
      >
        <div style={{ display: 'block' }}>{children}</div>
      </div>
    )
  }
}

export default compose(withFloorMap())(SpaceHoverPreview)
